// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownParagraphExtended } from '../../../assets/icons/extended/markdown/markdown-paragraph.svg?react';
import { createIcons } from '../../Icon';
const MarkdownParagraphIcon = /* @__PURE__ */ createIcons('MarkdownParagraph', {
    extended: MarkdownParagraphExtended
});
MarkdownParagraphIcon.supportedTypes = ['extended'];
MarkdownParagraphIcon.category = 'markdown';
export default MarkdownParagraphIcon;
